// i18n keys of the multi-tenant work package "jobrestore" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  jrm_title: 'Removed jobs',
  jrm_desc: 'A job is never erased — removing one only hides it, so everything it held is still on file: its number, its status, its amounts, its Sales Order and its filed documents. Restore puts it back on Active or Closed Jobs exactly as it was, and from then on nothing automatic can remove it again.',
  jrm_search_ph: 'Job number, client, job title or Sales Order',
  jrm_none: 'Nothing has been removed.',
  jrm_no_match: 'No removed job matches that.',
  jrm_removed: 'Removed {{when}} by {{who}}',
  jrm_removed_nodate: 'Removed by {{who}} (no date recorded)',
  jrm_reason: 'Reason:',
  jrm_by_unknown: 'an unrecorded operator',
  jrm_stand_in: 'Job #{{no}} now holds the same line of this document.',
  jrm_restore: 'Restore',
  jrm_confirm: 'Put job #{{no}} ({{title}}) back on the board?',
  jrm_confirm_stand_in: 'Put job #{{no}} ({{title}}) back on the board?\n\nJob #{{other}} now holds the same line of this document, so both will be listed until you decide which one the firm keeps.',
  jrm_restored: 'Job #{{no}} — {{title}} — is back under {{level}}. It had been removed {{when}} by {{who}}.',
  jrm_restored_nodate: 'Job #{{no}} — {{title}} — is back under {{level}}. It had been removed by {{who}}.',
  jrm_level: 'Status',
  jrm_so: 'Sales Order',
  jrm_total: 'Total',
};
export const zh: Record<string, string> = {
  jrm_title: '已移除的 Job',
  jrm_desc: 'Job 从不会被真正删除——移除只是将其隐藏,原有内容全部留档:编号、状态、金额、Sales Order 以及已归档文档。恢复后它会原样回到 Active Jobs 或 Closed Jobs,此后任何自动流程都不能再将其移除。',
  jrm_search_ph: 'Job 编号、客户、Job 名称或 Sales Order',
  jrm_none: '没有已移除的 Job。',
  jrm_no_match: '没有匹配的已移除 Job。',
  jrm_removed: '移除于 {{when}},操作人 {{who}}',
  jrm_removed_nodate: '移除人 {{who}}(未记录日期)',
  jrm_reason: '原因:',
  jrm_by_unknown: '未记录的操作人',
  jrm_stand_in: 'Job #{{no}} 目前占用本单据的同一行。',
  jrm_restore: '恢复',
  jrm_confirm: '确定将 Job #{{no}}({{title}})恢复到列表吗?',
  jrm_confirm_stand_in: '确定将 Job #{{no}}({{title}})恢复到列表吗?\n\nJob #{{other}} 目前占用本单据的同一行,恢复后两者都会显示,需由你决定保留哪一个。',
  jrm_restored: 'Job #{{no}} —— {{title}} —— 已恢复,状态为 {{level}}。原于 {{when}} 由 {{who}} 移除。',
  jrm_restored_nodate: 'Job #{{no}} —— {{title}} —— 已恢复,状态为 {{level}}。原由 {{who}} 移除。',
  jrm_level: '状态',
  jrm_so: 'Sales Order',
  jrm_total: '合计',
};
export const th: Record<string, string> = {
  jrm_title: 'งานที่ถูกนำออก',
  jrm_desc: 'งานจะไม่ถูกลบทิ้ง การนำออกเป็นเพียงการซ่อน ข้อมูลทั้งหมดยังอยู่ครบ ทั้งเลขที่งาน สถานะ จำนวนเงิน Sales Order และเอกสารที่จัดเก็บไว้ การกู้คืนจะนำงานกลับไปอยู่ใน Active Jobs หรือ Closed Jobs เหมือนเดิม และหลังจากนั้นระบบอัตโนมัติจะไม่สามารถนำออกได้อีก',
  jrm_search_ph: 'เลขที่งาน ชื่อลูกค้า ชื่องาน หรือ Sales Order',
  jrm_none: 'ไม่มีงานที่ถูกนำออก',
  jrm_no_match: 'ไม่พบงานที่ถูกนำออกตามที่ค้นหา',
  jrm_removed: 'นำออกเมื่อ {{when}} โดย {{who}}',
  jrm_removed_nodate: 'นำออกโดย {{who}} (ไม่มีการบันทึกวันที่)',
  jrm_reason: 'เหตุผล:',
  jrm_by_unknown: 'ผู้ดำเนินการที่ไม่ได้บันทึกไว้',
  jrm_stand_in: 'งาน #{{no}} ถืออยู่ในบรรทัดเดียวกันของเอกสารนี้แล้ว',
  jrm_restore: 'กู้คืน',
  jrm_confirm: 'นำงาน #{{no}} ({{title}}) กลับเข้ารายการหรือไม่',
  jrm_confirm_stand_in: 'นำงาน #{{no}} ({{title}}) กลับเข้ารายการหรือไม่\n\nงาน #{{other}} ถืออยู่ในบรรทัดเดียวกันของเอกสารนี้แล้ว ทั้งสองงานจะแสดงอยู่จนกว่าคุณจะตัดสินใจว่าจะเก็บงานใด',
  jrm_restored: 'งาน #{{no}} — {{title}} — กลับมาแล้วในสถานะ {{level}} เดิมถูกนำออกเมื่อ {{when}} โดย {{who}}',
  jrm_restored_nodate: 'งาน #{{no}} — {{title}} — กลับมาแล้วในสถานะ {{level}} เดิมถูกนำออกโดย {{who}}',
  jrm_level: 'สถานะ',
  jrm_so: 'Sales Order',
  jrm_total: 'ยอดรวม',
};
